import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnApplianceBaseType extends SnModel {
  @Expose()
  public name: string;

  @Expose()
  public maxCameras: number;

  @Expose()
  public recordingAllowed: boolean;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
